import React, { useEffect, useRef } from 'react';
import Lottie from 'react-lottie';
import menuBg from '../assets/animations/menu-bg.json'
import closeBtn from '../assets/icns/close.svg';
import instagram from '../assets/icns/instagram-icn.svg';
import linkedin from '../assets/icns/linkedin-icn.svg';
import behance from '../assets/icns/behance-icn.svg';


const Menu = ({ isOpen, closeMenu }) => {
  const lottieRef = useRef(null);
  const defaultOptions = {
    loop: false,
    autoplay: false,
    animationData: menuBg,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  useEffect(() => {
    if (isOpen && lottieRef.current && lottieRef.current.anim) {
      lottieRef.current.anim.goToAndPlay(0);
    }
  }, [isOpen]);

  return (
    <div className={`menu-overlay ${isOpen ? 'open' : 'close'}`} onClick={closeMenu}>
      <div 
      style={{
        transform: isOpen ? "translateX(0%)" : "translateX(110%)",
        transition: "transform 1s ease-in-out",}}

      className={`menu m-2 m-sm-3 d-flex flex-column rounded-4 z-1
        ${isOpen ? 'open' : 'close'}`} onClick={(e) => e.stopPropagation()}>
        
        <button className="close-button" onClick={closeMenu}>
          <img src={closeBtn} alt="Close" style={{ width: "20px" }} />
        </button>

        {/* <div className="lottie-background">
        <Lottie options={defaultOptions} height="100%" width="100%" ref={lottieRef} />
        </div> */}
        
        <nav className="p-0 p-sm-3 d-flex flex-column mb-5 mb-sm-5 ">
          <div className="menu-item d-inline-flex"><a className='' href='/' onClick={closeMenu} >Home</a></div>
          <div className="menu-item"><a className='' href='/works' onClick={closeMenu} >Works</a></div>
          <div className="menu-item"><a href='/about' onClick={closeMenu} >Bio</a></div>
          <div className="menu-item"><a href='/contact' onClick={closeMenu} >Contact</a></div>
          <div className="menu-item"><a href='/contact' onClick={closeMenu} >Get Quote</a></div>
        </nav>

          <div className='my-5'></div>

          <div className="d-flex gap-3 justify-content-between">
          
            <a href="mailto:hey@pazroth.com" className="social-icon text-dark"><p className='fs-5 fw-300'>hey@pazroth.com</p></a>

          <div className="ms-3 ms-sm-5 d-inline-flex align-items-baseline gap-3">
            <a href="https://www.instagram.com/paz_roth91/" className="social-icon"><img src={instagram} style={{ width: "25px" }} /></a>
            <a href="https://www.linkedin.com/in/pazroth/" className="social-icon"><img src={linkedin} style={{ width: "25px" }} /></a>
            <a href="https://www.behance.net/pazroth" className="social-icon"><img src={behance} style={{ width: "25px" }} /></a>
          </div>
          </div>

      </div>
    </div>
  );
}
  
  export default Menu;
  